import { ModalConfirmTemplateProps } from './';

const template: ModalConfirmTemplateProps = {
  ariaLabel: 'Confirm',
  renderHeader: () => <h2>Confirm Title</h2>,
  renderContent: () => <p>Lorem ipsum</p>,
};

export default template;
